var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_1150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.887 23.7739C18.4519 23.7739 23.7739 18.4519 23.7739 11.887C23.7739 5.32197 18.4519 0 11.887 0C5.32197 0 0 5.32197 0 11.887C0 18.4519 5.32197 23.7739 11.887 23.7739Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3698 11.8871H23.7736C23.7736 10.8142 23.6306 9.77484 23.3641 8.78613H11.3698V11.8871Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3698 5.68446H22.0289C21.3012 4.49706 20.3709 3.44753 19.2861 2.5835H11.3698V5.68446Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 23.7736C14.6843 23.7736 17.2556 22.8066 19.2861 21.1895H4.48724C6.51778 22.8066 9.08912 23.7736 11.8867 23.7736Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74448 18.0878H22.029C22.6132 17.1345 23.0662 16.0926 23.3642 14.9868H0.409286C0.70725 16.0926 1.1603 17.1345 1.74448 18.0878Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50626 1.85631H6.5895L5.5819 2.58834L5.96679 3.77281L4.95923 3.04078L3.95167 3.77281L4.28413 2.74955C3.39698 3.48854 2.6194 4.35434 1.97862 5.31904H2.32571L1.68433 5.785C1.5844 5.9517 1.48856 6.12104 1.39672 6.29289L1.70299 7.23553L1.13158 6.82037C0.989542 7.12131 0.859622 7.42902 0.742842 7.74314L1.08027 8.78177H2.32571L1.31811 9.51379L1.70299 10.6983L0.695433 9.96624L0.0918917 10.4048C0.0314819 10.8904 0 11.385 0 11.887H11.887C11.887 5.32201 11.887 4.54806 11.887 0C9.53872 0 7.34971 0.681178 5.50626 1.85631ZM5.96679 10.6983L4.95923 9.96624L3.95167 10.6983L4.33656 9.51379L3.32895 8.78177H4.57439L4.95923 7.5973L5.34407 8.78177H6.5895L5.5819 9.51379L5.96679 10.6983ZM5.5819 6.05106L5.96679 7.23553L4.95923 6.50351L3.95167 7.23553L4.33656 6.05106L3.32895 5.31904H4.57439L4.95923 4.13457L5.34407 5.31904H6.5895L5.5819 6.05106ZM10.2306 10.6983L9.22302 9.96624L8.21546 10.6983L8.60035 9.51379L7.59274 8.78177H8.83818L9.22302 7.5973L9.60786 8.78177H10.8533L9.84569 9.51379L10.2306 10.6983ZM9.84569 6.05106L10.2306 7.23553L9.22302 6.50351L8.21546 7.23553L8.60035 6.05106L7.59274 5.31904H8.83818L9.22302 4.13457L9.60786 5.31904H10.8533L9.84569 6.05106ZM9.84569 2.58834L10.2306 3.77281L9.22302 3.04078L8.21546 3.77281L8.60035 2.58834L7.59274 1.85631H8.83818L9.22302 0.671845L9.60786 1.85631H10.8533L9.84569 2.58834Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_1150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7739,
    height: 23.7739,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/USFlag.77d84b24967e67979816e5af24dc4660.svg";
export { ForwardRef as ReactComponent };